var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-range" }, [
    _vm.label
      ? _c("div", { staticClass: "c-range-label" }, [_vm._v(_vm._s(_vm.label))])
      : _vm._e(),
    _c("div", { staticClass: "c-range-wrapper" }, [
      _c(
        "div",
        { staticClass: "c-range-control" },
        [
          _c("vue-slider", {
            attrs: {
              duration: 0.2,
              "bg-style": _vm.bgStyle,
              height: 4,
              "process-style": _vm.processStyle,
              "dot-size": 16,
              max: +_vm.max,
              min: +_vm.min,
              "dot-style": _vm.dotStyle,
              "dot-options": _vm.dotOptions,
            },
            model: {
              value: _vm.localValue,
              callback: function ($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "c-range-values" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localValue[0],
              expression: "localValue[0]",
            },
          ],
          staticClass: "c-range-input",
          attrs: { type: "number", min: _vm.min, max: _vm.max, step: "1" },
          domProps: { value: _vm.localValue[0] },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.localValue, 0, $event.target.value)
            },
          },
        }),
        _c("div", { staticClass: "c-range-separator" }),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localValue[1],
              expression: "localValue[1]",
            },
          ],
          staticClass: "c-range-input",
          attrs: { type: "number", min: _vm.min, max: _vm.max, step: "1" },
          domProps: { value: _vm.localValue[1] },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.localValue, 1, $event.target.value)
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }